import { RouterProvider } from "react-router-dom";
import ModalContainer from "./components/modal/modal-container";
import ToastContainer from "./components/toast/toast.container";
import router from "./router";
import "./styles/app.scss";
import Loading from "@core/components/loading";
import { useEffect } from "react";
import useCancellationRequest from "@core/hooks/use-cancellation-request.hook";
import { BUCKET_URL_KEY, MobileOS, USER_INFO_KEY } from "./constants";
import StorageService from "@core/services/storage";
import { useDispatch, useSelector } from "react-redux";
import { clearUser, selectAuth, storeUser } from "./store/auth";
import axios from "axios";
import { Environment } from "@environments/environment";
import HttpService from "@core/services/http/http.service";
import { GetDetailResponse, User } from "./types";
import { clearLocalStorage, getMobileOperatingSystem } from "./utils/util";
import Audiobook from "./components/audiobook";
import { openPortalDialog } from "./services/modal.service";
import InstallAppModal from "./components/install-app-modal";
import CategoryModal from "./components/category-modal";
import CategoryService from "./services/http/category.service";
import UserService from "./services/http/user.service";

interface BucketUrl {
  value: string;
}

function App() {
  const { abortController } = useCancellationRequest();

  const dispatch = useDispatch();

  const { id, categoryIds } = useSelector(selectAuth);

  useEffect(() => {
    const accessToken = HttpService.getAccessToken();

    if (accessToken) {
      axios
        .get<GetDetailResponse<User>>(
          `${Environment.BASE_API}/user/api/v2/auth/info`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
            signal: abortController.signal,
          }
        )
        .then((res) => {
          StorageService.setObject(USER_INFO_KEY, res.data.data);
          dispatch(storeUser(res.data.data));
        })
        .catch(() => {
          clearLocalStorage();
          dispatch(clearUser());
        });
    }
  }, []);

  useEffect(() => {
    axios
      .get<GetDetailResponse<BucketUrl>>(
        `${Environment.BASE_API}/user/api/v3/setting/bucket-url`,
        {
          signal: abortController.signal,
        }
      )
      .then((res) => {
        const bucketUrl = res.data.data?.value || "";

        StorageService.set(BUCKET_URL_KEY, bucketUrl);
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (id && !categoryIds.length) {
      CategoryService.getAllV2().then((res) => {
        const categoryModal = openPortalDialog(CategoryModal, {
          categories: res.data.items,
          categoryIds,
        });

        categoryModal.afterClosed().subscribe((data) => {
          if (data?.categorySelectionIds) {
            UserService.updateFavoriteCategories(data.categorySelectionIds);
          }
        });
      });
    }
  }, [id, categoryIds]);

  useEffect(() => {
    const os = getMobileOperatingSystem();

    if ([MobileOS.ANDROID, MobileOS.IOS].includes(os as any)) {
      openPortalDialog(InstallAppModal);
    }
  }, []);

  // useEffect(() => {
  //   const detectDevTools = () => {
  //     const threshold = 160;
  //     const isDevToolsOpen =
  //       window.outerWidth - window.innerWidth > threshold ||
  //       window.outerHeight - window.innerHeight > threshold;

  //     if (isDevToolsOpen) {
  //       alert("Developer tools are open! Please close them.");
  //     }
  //   };

  //   const interval = setInterval(detectDevTools, 1000);

  //   return () => clearInterval(interval);
  // }, []);

  return (
    <>
      <RouterProvider router={router} />
      <div id="toast-root">
        <ToastContainer />
      </div>
      <div id="modal-root">
        <ModalContainer />
      </div>
      <div id="loading-root">
        <Loading />
      </div>
      <div id="audiobook-root">
        <Audiobook />
      </div>
    </>
  );
}

export default App;
